import {ChangeEventHandler} from 'react';

interface IProps {
  size?: 'small' | 'medium';
  isChecked: boolean;
  disabled?: boolean;
  onChange?: ChangeEventHandler;
}

// https://www.w3schools.com/howto/howto_css_switch.asp 참고
// 스타일 코드들을 수정할 일이 있을 때, 위 url을 참고할 수 있으므로 @apply만 적용하고 scss로 남겨놓는다.
export default function SwitchToggleV4({
  size = 'medium',
  isChecked,
  disabled,
  onChange,
}: IProps) {
  const {labelCn, spanCn} = TOGGLE_CN_MAP[size];
  return (
    <label className={cn('inline-block relative', labelCn)}>
      <input
        disabled={disabled}
        onChange={onChange}
        type="checkbox"
        defaultChecked={isChecked}
        className="h-0 opacity-0 w-0"
      />
      <span
        className={cn(
          'cursor-pointer inset-0 absolute transition duration-300 rounded-12',
          'before:bg-white before:bottom-3 before:left-3 before:absolute',
          'before:transition before:duration-300 before:rounded-50per',
          isChecked
            ? 'bg-red before:translate-x-[calc(100%-3px)]'
            : 'bg-dark-grey-04 light:bg-grey-03',
          spanCn
        )}
      />
    </label>
  );
}

const TOGGLE_CN_MAP = {
  small: {
    labelCn: 'w-32 h-20',
    spanCn: 'before:w-14 before:h-14',
  },
  medium: {
    labelCn: 'w-40 h-24',
    spanCn: 'before:w-18 before:h-18',
  },
};
